/**
 * Страница «е. формат».
 */
function main(): void
{
	const eFormatAdvantages = document.querySelectorAll( 'section.e-format-advantages > ul > li' );

	if ( !eFormatAdvantages.length )
	{
		return;
	}

	Array.from( eFormatAdvantages ).forEach( ( it : HTMLLIElement, i : number ) => {
		const showIfItsTime = ( notTriggered : boolean | Event ) => {
			if ( it.getBoundingClientRect().top < window.innerHeight )
			{
				const timeout = typeof notTriggered === 'boolean' ? 1750 * i : 0;

				const animationTimeout = setTimeout( () => {
					it.classList.add( 'show' );
					window.removeEventListener( 'scroll', showIfItsTime );
					clearTimeout( animationTimeout );
				}, timeout );
			}
		};

		showIfItsTime( true );
		window.addEventListener( 'scroll', showIfItsTime );
	} );
}

/**
 * Module.
 */
export {
	main as default,
};


// WEBPACK FOOTER //
// ./app/Routes/EFormat/index.ts